export function validateInput(question, value) {
  if (!value) {
    return "This field is required.";
  }

  if (question.type === "date") {
    const selectedDate = new Date(value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (selectedDate < today) {
      return "Please select a date in the future.";
    }
  }

  // Email validation using a simple regex
  if (question.validationType === "email") {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return "Please enter a valid email address.";
    }
  }

  // Phone validation (very basic, checks for at least 10 digits)
  if (question.validationType === "phone") {
    const phoneRegex = /\d/g;
    const digits = (value.match(phoneRegex) || []).length;
    if (digits < 10) {
      return "Please enter a valid phone number.";
    }
  }

  return null; // Return null if validation passes
}
